import api from './api';

const dashboardManagerService = {
    // Dashboard Content
    getDashboardContent: async () => {
        const response = await api.get('/admin/dashboard-content');
        return response.data.data;
    },

    updateDashboardContent: async (data) => {
        const response = await api.put('/admin/dashboard-content', data);
        return response.data.data;
    },

    // Advertisements
    getAllAdvertisements: async (params = {}) => {
        const response = await api.get('/admin/advertisements', { params });
        return response.data.data;
    },

    getAdvertisementById: async (id) => {
        const response = await api.get(`/admin/advertisements/${id}`);
        return response.data.data;
    },

    createAdvertisement: async (formData) => {
        const response = await api.post('/admin/advertisements', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data.data;
    },

    updateAdvertisement: async (id, formData) => {
        const response = await api.put(`/admin/advertisements/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data.data;
    },

    deleteAdvertisement: async (id) => {
        const response = await api.delete(`/admin/advertisements/${id}`);
        return response.data;
    },

    // Hero Banners
    getAllHeroBanners: async (params = {}) => {
        const response = await api.get('/admin/hero-banners', { params });
        return response.data.data;
    },

    getHeroBannerById: async (id) => {
        const response = await api.get(`/admin/hero-banners/${id}`);
        return response.data.data;
    },

    createHeroBanner: async (formData) => {
        const response = await api.post('/admin/hero-banners', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data.data;
    },

    updateHeroBanner: async (id, formData) => {
        const response = await api.put(`/admin/hero-banners/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data.data;
    },

    deleteHeroBanner: async (id) => {
        const response = await api.delete(`/admin/hero-banners/${id}`);
        return response.data;
    },

    // Home section text (heading + subheading) by section key
    getHomeSection: async (key) => {
        const response = await api.get(`/admin/home-sections/${key}`);
        return response.data.data;
    },

    upsertHomeSection: async (key, payload) => {
        const response = await api.put(`/admin/home-sections/${key}`, payload);
        return response.data.data;
    },
};

export default dashboardManagerService;
